import { Typography } from '@capsule/consumer-design-system';

import styled from 'styled-components';

export const MedGuideContainer = styled(Typography)`
  padding: ${({ theme }) => theme.space.s5};
  background-color: ${({ theme }) => theme.colors.white};

  &&& * {
    font-size: ${({ theme }) => theme.fontSizes.body};
  }

  &&& h1 {
    font-size: ${({ theme }) => theme.fontSizes.headerOne};
  }

  & > .Contents > .Section {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.space.s2};
    color: ${({ theme }) => theme.colors.capsuleBlue50};
  }

  & > .Contents > .Section > *:empty {
    display: none;
  }

  table,
  tr,
  td {
    border: none;
    width: 100% !important;
  }

  span.Bold {
    font-weight: bold;
  }

  li {
    margin-left: ${({ theme }) => theme.space.s5};

    margin-top: ${({ theme }) => theme.space.s2};
    &:last-child {
      margin-bottom: ${({ theme }) => theme.space.s3};
    }
  }
`;
